import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of, tap } from 'rxjs';

import { TranslationService } from '../../shared/services/translation.service';
import { UserService } from '../../shared/services/user.service';

import { ProductService } from './product.api.service';

@Injectable({ providedIn: 'root' })
export class AppOfferService {
	private productFieldNamesLoaded = false;
	private configurationFieldNamesLoaded = false;

	constructor(
		private readonly productService: ProductService,
		private readonly userService: UserService,
		private readonly translationService: TranslationService,

		private readonly snackBar: MatSnackBar
	) {}

	showMessage(msg: string) {
		this.snackBar.open(
			msg,
			undefined,
			{ duration: 5000 }
		);
	}

	showError(msg?: string) {
		this.snackBar.open(
			msg === undefined
				? this.translationService.getTR('quapp.error')
				: `${ this.translationService.getTR('quapp.error') } - ${ msg }`,
			undefined,
			{ duration: 5000 }
		);
	}

	resetProductFieldNamesLoaded() {
		this.productFieldNamesLoaded = false;
	}

	loadProductFieldNames() {
		if (this.productFieldNamesLoaded) {
			return of(false);
		}
		return this.productService.loadFieldNameTranslations(true).pipe(tap(
			() => {
				this.productFieldNamesLoaded = true;
			}
		));
	}

	loadConfigurationFieldNames() {
		if (this.configurationFieldNamesLoaded) {
			return of(false);
		}
		return this.productService.loadFieldNameTranslations(false).pipe(tap(
			() => {
				this.configurationFieldNamesLoaded = true;
			}
		));
	}

	getBocs() {
		return this.userService.getSoldToRelationshipGroupsTransac('EOFFR');
	}
}
